<template>
    <b-modal title="Upload Branding Image" :id="id" @ok="handleOk" @show="loadImage">
        <b-row v-if="imageSrc" >
            <b-col>
                <div class="p-2 border rounded mb-3">
                    <b-img-lazy :src="imageSrc" />
                </div>
            </b-col>
        </b-row>
        <b-row class="my-1">
            <b-col>
                <b-form-file id="store-branding" v-model="uploadDocument" accept="image/*"
                    drop-placeholder="Drop image here..." placeholder="Choose Store Branding Image or drop one here." />

                <b-alert show variant="secondary" style="color: black;" class="mt-4">
                    <small>
                        <strong>
                            <i class="fa fa-info-circle" style="font-size: 1.1em;"></i>
                            Image Requirements
                        </strong><br>
                        Image Format: JPG, PNG<br>
                        Maximum Size: 2.667 inches wide; 1 inch tall<br>
                        Recommended: 800 pixels by 300 pixels at 300 pixels per inch
                    </small>
                </b-alert>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script lang="ts">
import { Store } from '@/models/Store';
import axios from 'axios';
import { Vue, Component, Prop, VModel, Watch } from 'vue-property-decorator';
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import { BvModalEvent } from "bootstrap-vue";

@Component({})
export default class BrandingModal extends Vue {
    @Prop({ default: "branding-modal", type: String }) private id!: string;
    @VModel() private store!: Store;
    private uploadDocument: File = new File([], "");
    private imageSrc: string = "";

    async loadImage(): Promise<string> {
        if (!this.store.brandingImageId) return Promise.reject("no image id");

        try {
            let blob = await axios.get(`/api/Image/${this.store.brandingImageId}`, { responseType: "blob" });
            const objectUrl = URL.createObjectURL(blob.data);
            return objectUrl;
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }

        return `${axios.defaults.baseURL}/image/${this.store.brandingImageId}`;
    }

    @Watch('store')
    async storeUpdate(_newVal: Store, _oldVal: Store) {
        this.resetForm();
        try {
            this.imageSrc = await this.loadImage();
        } catch (_err) {
            // swallow
        }
    }

    handleOk(event: BvModalEvent) {
        event.preventDefault();
        this.uploadBranding();
    }

    uploadBranding() {
        const formData = new FormData();
        formData.append('document', this.uploadDocument, this.uploadDocument.name.trim());

        console.log("formData: ", JSON.stringify(formData));

        axios.post(`/api/Store/${this.store.id}/branding`,
            formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(resp => {
                console.log("branding resp: ", resp);

                if (resp.data?.brandingImageId) {
                    this.store.brandingImageId = resp.data.brandingImageId;
                    this.$emit('image-uploaded');
                }

                this.resetForm();
                this.$nextTick(() => {
                    this.$bvModal.hide(this.id);
                });
            })
            .catch(err => {
                // A size rejection names the measured size, the resolution it was measured at and two
                // different ways to fix the file. The shared 10s timeout is not long enough to read that,
                // let alone note down the numbers, so this one notification is given longer.
                this.$notification({ ...NotificationOptions.error(err), timeout: 30000 });
            });
    }

    resetForm() {
        this.uploadDocument = new File([], "");
        this.imageSrc = "";
    }
}
</script>

<style scoped></style>
